import React, {useState} from "react"
import { graphql, Link } from "gatsby"
import SEO from "../components/seo"
import Layout from "../components/layout"
import CustomMarkdown from "../utils/customMarkdown"
import useSiteMetadata from "../utils/useSiteMetadata"
import { removeSlashFromSlug } from '../utils/additionalFunctions';
import Img from "gatsby-image";
import GetImgUrl from "../utils/customFunctions";
import loadable from '@loadable/component'

import "../scss/legal.scss"
import 'uikit/dist/css/uikit.css'

export const query = graphql`
query legalsQuery($id: Int) {
  strapiLegals(strapiId: {eq: $id}) {
    SEOTitle
    SEODescription
    Canonical
    MetaTags{
      MetaName
      MetaContent
    }
    Title
    Content
    slug
    strapiId
    PageComponents
  }

}
`

const Branches = loadable(() => import("../components/branches-component"))
const Tiles = loadable(() => import("../components/tiles"))
const Hero = loadable(() => import("../components/basic-components/hero"))
const QuoteCarousel = loadable(() => import("../components/quote-carousel"))
const Paragraph = loadable(() => import("../components/paragraph"))
const VideoComponent = loadable(() => import("../components/video-component"))
const StepsComponent = loadable(() => import("../components/steps-component"))
const FAQComponent = loadable(() => import("../components/faq-component"))
const SwirlComponent = loadable(() => import("../components/swirl-component"))
const Signup = loadable(() => import("../components/signup"))
const MapComponent = loadable(() => import("../components/map-component"))
const BranchLocator = loadable(() => import("../components/branch-locator"))
const InfiniteImageCarousel = loadable(() => import("../components/infinite-image-carousel"))
const InfiniteTextCarousel = loadable(() => import("../components/infinite-text-carousel"))

const Legal = ({data, pageContext}) => {

  
  const { siteUrl: url } = useSiteMetadata();
  const pageHasHeader = data.strapiLegals.Header != null ? true : false; //check if Header is set
  const [headerParagraphSet, setHeaderParagraphSet] = useState(false);

    return(
    <div>
      <Layout type="privacy">
        <SEO title={data.strapiLegals.SEOTitle?data.strapiLegals.SEOTitle:data.strapiLegals.Title} 
        description={data.strapiLegals.SEODescription} 
        meta={data.strapiLegals.MetaTags}
        canonical={data.strapiLegals.Canonical ? data.strapiLegals.Canonical : `${url + '/' + removeSlashFromSlug(data.strapiLegals.slug)}`}
        />

        <div className="title"><h1>{data.strapiLegals.Title}</h1></div>

        <section className="legal-section">
             
            <CustomMarkdown children={data.strapiLegals.Content}></CustomMarkdown>        
          
        </section>

        {data.strapiLegals.PageComponents.map((item, index) => {
            
            switch (item.strapi_component) {
              case "basic-components.paragraph":
                var forceH1Title = false;
                var overlaySwirl = false;
                if((pageHasHeader == false && headerParagraphSet == false) || item.IsHeader == true){
                  setHeaderParagraphSet(true);
                  forceH1Title = true;
                }

                if(index == 0 && item.TopSwirl == true){ //if paragraph is the first item in pageComponents and has topSwirl then overlay the header image
                  overlaySwirl = true;
                }
                return (               
                    <Paragraph
                        key={index}
                        title={item.Title}
                        text={item.Text}
                        image={item.Image}
                        imagePosition={item.ImagePosition}
                        bgColor={item.BackgroundColor || ""}
                        topPadding={(item.TopPadding === true) ? true : false}
                        bottomPadding={(item.BottomPadding === true) ? true : false}
                        forceH1Title={forceH1Title}
                        alignment={item.ContentAlignment}
                        initialPadding={item.InitialPadding}
                        topSwirl={item.TopSwirl}
                        bottomSwirl={item.BottomSwirl}
                        bottomMargin={item.BottomMargin}
                        overlaySwirl={overlaySwirl}
                        leftPadding={item.LeftPadding}
                        rightPadding={item.RightPadding}
                    ></Paragraph>
                )
              case "basic-components.hero-section":
                return(
                  <Hero                 
                    title={item.Hero.Title}
                    description={item.Hero.Description}
                    label={item.Hero.Label}
                    url={item.Hero.url}
                    key={index}
                    sectionStyle = "white"
                  ></Hero>
                )
              case "basic-components.branches-component":
                const branchesBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                return(
                  <Branches key={index} branchList={item.BranchesList} title={item.Title} sectionStyle={branchesBgColor} />
                )
              case "basic-components.video-section":
                return(
                  <div key={index}>
                    <VideoComponent src={item.YoutubeURL}/>
                  </div>
                  
                )
              case "basic-components.testimonial-section":
                return(
                      <QuoteCarousel key={index} quoteList={item.Testimonial}></QuoteCarousel>
                )
              case "cta.cta-section":
                const sectionBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                const fullWidthSectionBgColo =  item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'white'; 
                return(
                  <div key={index}>
                    {item.CTA !== undefined && item.CTA.length > 1 ? (<Tiles data={item.CTA} width='half' key={index} sectionStyle={sectionBgColor}></Tiles>) : ("")}

                    {item.CTA !== undefined && item.CTA.length === 1 ? (<Tiles data={item.CTA} key={index} singleFlag={true} width='full' sectionStyle={fullWidthSectionBgColo}></Tiles>) : ("")
                      // (item.CTA !== null && Object.keys(item.CTA).length === 1)?<Tiles data={item.CTA} singleFlag={true}></Tiles>:""
                      //don't forget to fix this once the cta.length of a json (dynamic zone) is found
                    }
                  </div>
                )
                case "basic-components.text-section":
                  return (
                    <>
                      <CustomMarkdown key={index} children={item.Text} />
                      {item.Links ? (
                          <Link to={item.Links.URL}>
                            {item.Links.Link}
                          </Link>
                        ) : null}
                    </>           
                  )
                case "basic-components.image-carousel-section":
                  return(
                      item.ImageCarousel ? (
                          <div key={index} className="image-section uk-height-medium uk-cover-container uk-margin-none">
                            <Img
                              fluid={
                                GetImgUrl(item.ImageCarousel.Images.localFile___NODE)
                                  .fluid
                              }
                              alt="image"
                            ></Img>
                          </div>
                      ) : null
                  )
                case "basic-components.image-carousel":
                  return (                     
                        item.Images 
                        ? ( <div key={index} className="image_wrap">
                          <div className="image-section uk-cover-container uk-margin-none">
                            <Img
                              fluid={GetImgUrl(item.Images.localFile___NODE).fluid}
                              alt={"image"}
                              data-uk-cover
                            ></Img>
                          </div>
                        </div>
                        ) 
                        : ("")                                                 
                  )
                case "basic-components.steps-component":
                  return(
                    <StepsComponent key={index} stepsList={item.StepsList} sectionStyle="white" />
                  )
                case "basic-components.faq-component":
                  return(
                    <FAQComponent key={index} faqList={item.FAQList} sectionStyle="white" />
                  )             
                case "basic-components.signup-component":
                  return(
                    <Signup
                      title="Sign Up to Our Newsletter"
                      description="Get updates on all the lastest information, or stay informed about our courses"
                      buttonLabel="Sign Up"
                      sectionStyle = "white"
                    />
                  )
                case "basic-components.swirl-component":                
                  return(
                    <SwirlComponent 
                      key={index} 
                      bgColor={item.SwirlColor} topSwirl={item.Position == "Top" ? true : false} 
                      />
                  )
                case "basic-components.map-component":                
                  return(
                    <MapComponent 
                      key={index} 
                      title={item.Title}
                      gMapsLocation={item.GMapsLocation} 
                      />
                  )
                case "basic-components.branch-locator":                
                  return(
                    <BranchLocator 
                      key={index} 
                      title={item.Title}
                      subtitle={item.Subtitle}
                      branchesList={item.Branches} 
                      />
                  )
                case "basic-components.infinite-image-carousel":                
                  return(
                    <InfiniteImageCarousel 
                      key={index} 
                      title={item.Title}
                      imageList={item.LinkImageList} 
                      backgroundColor={item.BackgroundColor}
                      />
                  )
                case "basic-components.infinite-text-carousel":                
                  return(
                    <InfiniteTextCarousel 
                      key={index} 
                      title={item.Title}
                      textList={item.LinkTextList} 
                      backgroundColor={item.BackgroundColor}
                      />
                  )
                default:
                  return ('')
            }
          }
        )} 

      </Layout>
  
    </div>
  )
    }
  
  export default Legal